import styled from "styled-components";

export const JoinTypeItem = styled.li``;

export const JoinTypeText = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.inputLabel};
  font-size: 1.6rem;
  font-weight: 700;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  p {
    margin: 0;
    color: ${(props) => props.theme.colors.black50};
    font-size: 1.1rem;
    font-weight: 500;
    text-align: center;
    line-height: 1.6rem;
  }
`;

export const JoinTypeLabel = styled.label`
  display: flex;
  width: 100%;
  padding: 20px 18px;
  flex-direction: column;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.button};
  align-items: center;
  gap: 16px;

  &:has(input:checked) {
    border: 1px solid ${(props) => props.theme.colors.primary100};
    box-shadow: none;

    ${JoinTypeText} {
      color: ${(props) => props.theme.colors.primary100};

      p {
        color: ${(props) => props.theme.colors.black80};
      }
    }
  }
`;

export const JoinTypeRadio = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid ${(props) => props.theme.colors.inputBg};
  border-radius: 50%;

  svg {
    display: none;
  }

  input {
    display: none;

    &:checked + svg {
      display: initial;
    }
  }

  &:has(input:checked) {
    border: none;
  }
`;

export const JoinTypeContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: 16px;

  img {
    width: 100%;
    object-fit: contain;
    object-position: bottom;
  }
`;
